import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { localeTag } from "@/i18n";
import { useSettings } from "@/lib/useSettings";
import { visibleTiles, useHomeSummary } from "@/components/home/tiles";
import { isSimple } from "@/lib/edition";

const Subs = ({ t, onGo }) => (
  <div className="flex flex-wrap gap-1.5">
    {t.subs.map((x, k) => (
      <button key={x.to} type="button" onClick={(e) => { e.stopPropagation(); onGo(x.to); }} data-testid={`home-tile-${t.key}-sub-${k}`}
        className="px-2.5 py-1 rounded-full text-xs font-semibold bg-white/75 dark:bg-white/10 border border-black/5 dark:border-white/10 active:scale-95 transition-transform">
        {x.label}
      </button>
    ))}
  </div>
);

const Tile = ({ t, s, mail, i, onGo, simple }) => (
  <div role="button" tabIndex={0} onClick={() => onGo(t.to)} onKeyDown={(e) => e.key === "Enter" && onGo(t.to)} data-testid={`home-tile-${t.key}`}
    style={{ animationDelay: `${i * 45}ms` }}
    className={`relative rounded-2xl border p-4 flex flex-col gap-2.5 cursor-pointer select-none shadow-sm animate-in-up active:scale-[0.97] transition-transform duration-150 ${t.tone} ${t.featured ? "col-span-2 md:col-span-3 ring-2 ring-amber-400/40 p-5" : t.wide ? "col-span-2 md:col-span-1 min-h-[148px]" : "min-h-[148px]"}`}>
    <div className="flex items-start gap-3">
      <div className={`w-12 h-12 rounded-xl ${t.iconBg} text-white flex items-center justify-center shrink-0 shadow-sm`}><t.icon className="w-6 h-6" /></div>
      {t.featured && (
        <div className="min-w-0">
          <div className="font-heading font-extrabold text-xl leading-tight">{t.title}</div>
          <div className="text-sm opacity-80 mt-0.5 leading-snug">{simple && t.simpleDesc ? t.simpleDesc : t.desc}</div>
        </div>
      )}
      {t.alert?.(s) && <span className="ml-auto w-3 h-3 rounded-full bg-[#DC2626] animate-pulse shrink-0" data-testid={`home-tile-${t.key}-alert`} />}
    </div>
    {!t.featured && <div className="font-heading font-bold text-[17px] leading-tight">{t.title}</div>}
    <div className="text-xs font-semibold opacity-80 mt-auto" data-testid={`home-tile-${t.key}-count`}>{t.count(s, mail)}</div>
    {t.subs?.length > 1 && <Subs t={t} onGo={onGo} />}
  </div>
);

// Pagina iniziale per telefono e tablet: 7 tasti grandi, uno per ogni attività principale.
export const HomeTiles = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";
  const simple = isSimple(user);
  const { s, mail } = useHomeSummary(isAdmin, simple);
  const settings = useSettings();
  const h = new Date().getHours();
  const hello = h < 13 ? "Buongiorno" : h < 18 ? "Buon pomeriggio" : "Buonasera";
  const ditta = settings?.ragione_sociale || user?.company?.ragione_sociale || "";
  const name = ditta ? `, ${ditta}` : "";
  return (
    <section className="space-y-4" data-testid="home-tiles">
      <div>
        <div className="font-heading text-2xl font-extrabold tracking-tight" data-testid="home-greeting">{hello}{name}!</div>
        <div className="text-sm text-muted-foreground capitalize">{new Date().toLocaleDateString(localeTag(), { weekday: "long", day: "numeric", month: "long" })}</div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {visibleTiles(isAdmin, simple).map((t, i) => <Tile key={t.key} t={t} s={s} mail={mail} i={i} onGo={navigate} simple={simple} />)}
      </div>
    </section>
  );
};

export default HomeTiles;
